var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, EventEmitter, Output } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MatFieldComponent } from '../../../common/components';
import { FacebookLoginButtonComponent } from '../../../common/components/facebook.login.button/facebook.login.button.component';
import { ImageComponent } from '../../../common/components/image/image.component';
import { ModalService } from '../../../common/services/modal.service';
import { HubPlace } from '../../../models/hub/hub.place';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef, MatMenuTrigger } from '@angular/material';
import { PlaceDetailsModalActions } from 'components/visitor/place.details.modal/place.details.modal.provider';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';
import { ConfigService } from '../../../services/config.service';
import { CustomizationApiService } from '../../../services/customization.api.service';
import { ImageService } from '../../../services/image.service';
import { PlaceService } from '../../../services/place.service';
import { ShareService } from '../../../services/share.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { config } from '../../../../config/config';
import { AllFrontendSettingsStore, VisitorCalendarStore, VisitorStyleStore, VisitorTripNotifyAddOrRemoveItemStore, } from '../../../stores/visitor.calendar.store';
import { ShowInfoModalComponent } from '../../hub/show.info.modal/show.info.modal.component';
import { ShowInfoModalActions, InfoModalData } from '../../hub/show.info.modal/show.info.modal.provider';
import { ImageViewerComponent } from 'common/components/image.viewer/image.viewer.component';
import { GlobalEventEmitter } from '../../../common/services/global.event.emitter';
import { SeoService } from '../../../services/seo.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertifyService } from '../../../services/alertify.service';
var PlaceDetailsModalComponent = /** @class */ (function (_super) {
    __extends(PlaceDetailsModalComponent, _super);
    function PlaceDetailsModalComponent(dialogRef, actions, visitorApiService, modalService, imageService, location, router, formBuilder, allFrontendSettingsStore, customizationApiService, visitorCalendarStore, visitorStyleStore, notifyAddOrRemoveItemStore, sanitizer, alertify, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.visitorApiService = visitorApiService;
        _this.modalService = modalService;
        _this.imageService = imageService;
        _this.location = location;
        _this.router = router;
        _this.formBuilder = formBuilder;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.customizationApiService = customizationApiService;
        _this.visitorCalendarStore = visitorCalendarStore;
        _this.visitorStyleStore = visitorStyleStore;
        _this.notifyAddOrRemoveItemStore = notifyAddOrRemoveItemStore;
        _this.sanitizer = sanitizer;
        _this.alertify = alertify;
        _this.placePhotos = [];
        _this.priceLevel = [];
        _this.isAccommodation = false;
        _this.placeImagesShownCount = 5;
        _this.imageHeight = 350;
        _this.mapColumnMaxHeight = 703;
        _this.inforRowHeight = 0;
        _this.facebookLogo = config.facebook.logo;
        _this.placeFeedRows = [];
        _this.isLoadingAllPlaces = false;
        _this.isLoadingPlace = false;
        _this.isMatchCompleted = false;
        _this.isGooglePlaceMatchedWithFBPlace = false;
        _this.isGoogleInfoLoaded = false;
        _this.isKeepTempClosedPlaceInApproved = false;
        _this.allPlaces = [];
        _this.mapZoom = 16;
        _this.hideIconMapStyler = ConfigService.config.google.hideMapBusinessIconStyles;
        _this.featuresToggle = new HubVisitorFeatureToggle();
        _this.placeSource = 'facebook';
        _this.analytics = new PlaceAnalytics();
        _this.place = data;
        return _this;
    }
    // @HostListener('window:popstate', ['$event'])
    // public hashChanged() {
    //     // solve the browser's back button is triggered, place calendar shows empty content issue
    //     setTimeout(() => {
    //         console.log('back btn', this.router.url);
    //         if (this.router.url.includes('/trips')) {
    //             // navigate to trip page in visitor.trip.component.ts
    //         } else {
    //             this.router.navigateByUrl(
    //                 getRouteUrl(routeConfigs.visitor.placeCalendar, {
    //                     hubName: this.hubName,
    //                     category: 'All',
    //                     menuType: 'normal',
    //                 }),
    //                 { skipLocationChange: this.noChangeUrlWhenRedirect }
    //             );
    //         }
    //     }, 200);
    // }
    /**
     * handle browser back button click, close the event details page
     * only close the details page is not enough, it will always have other loading issues for the script embedding solution
     * so force reload the page for now
     * */
    PlaceDetailsModalComponent.prototype.hashChanged = function ($event) {
        $event.preventDefault();
        console.log('prevent default');
        var url = window.location.href.split('imgoing-place')[0];
        url = url.endsWith('?') ? url.substring(0, url.length - 1) : url;
        window.location.href = url;
        this.close();
    };
    Object.defineProperty(PlaceDetailsModalComponent.prototype, "contentLoaded", {
        get: function () {
            return (this.place &&
                ((this.place.socialName === 'google' && this.isGoogleInfoLoaded) || this.place.socialName !== 'google'));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlaceDetailsModalComponent.prototype, "hasDescription", {
        get: function () {
            return this.place.description || this.place.about;
        },
        enumerable: true,
        configurable: true
    });
    PlaceDetailsModalComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.facebookLogo = this.imageService.imageSourceUrl(this.facebookLogo);
        // this component cannot get the Facebook login event (don't know why so far), so it uses this global event emitter to receive the login status
        GlobalEventEmitter.on('onFBLoginStatusChanged', function () {
            console.log('onFBLoginStatusChanged received');
            _this.getFacebookPlaceFeed(null);
        });
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.toggle) {
                _this.featuresToggle = command.toggle;
                _this.placeSource = command.dataSource ? command.dataSource.place : _this.place.socialName || 'facebook';
            }
            if (command.customSettings && command.customSettings.placeImagesShownCount) {
                _this.placeImagesShownCount = command.customSettings.placeImagesShownCount;
            }
            if (command.customSettings && command.customSettings.isKeepTempClosedPlaceInApproved) {
                _this.isKeepTempClosedPlaceInApproved = command.customSettings.isKeepTempClosedPlaceInApproved;
            }
        });
        // this.hubName = data.hubName;
        // if (data && data.placeId) { // placeId, from VisitorCalendarComponent
        //     this.loadPlaces(data.placeId, data.hubName);
        // } else {
        //     this.loadItem(data);
        // }
        this.hubName = this.place.hubName;
        if (this.place && this.place.placeId) {
            // No place details loaded, need to load. placeId, from VisitorCalendarComponent
            this.loadPlaces(this.place.placeId, this.place.hubName);
        }
        else {
            this.loadItem(this.place);
        }
    };
    PlaceDetailsModalComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        GlobalEventEmitter.off('onFBLoginStatusChanged');
        if (config.isAnalyticsOn) {
            console.log('destroy', this.analytics);
            this.visitorApiService.updatePlaceAnalytics(this.hubName, this.place.id, this.analytics).subscribe();
        }
    };
    Object.defineProperty(PlaceDetailsModalComponent.prototype, "noPostBackground", {
        get: function () {
            return (((this.place.socialName === 'facebook' || this.place.isManuallyCreated) &&
                (!this.place.hostLink || this.place.hostLink.indexOf('facebook.com/') < 0)) ||
                (this.place.socialName === 'google' && !this.googleReviews));
        },
        enumerable: true,
        configurable: true
    });
    PlaceDetailsModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    PlaceDetailsModalComponent.prototype.confirm = function (event) {
        this.actions.confirm(event);
        this.dialogRef.close();
    };
    PlaceDetailsModalComponent.prototype.loadPlaces = function (placeId, hubName) {
        var _this = this;
        this.isLoadingPlace = true;
        this.getPlaceById(hubName, placeId || this.place._id).subscribe(function (p) {
            _this.isLoadingPlace = false;
            if (p && p.length) {
                _this.loadItem(p[0]);
            }
            else {
                _this.modalService.showErrorModal('Place id is wrong!');
            }
        });
    };
    PlaceDetailsModalComponent.prototype.getFBPost = function (placeId) {
        var _this = this;
        if (placeId) {
            FB.api(config.facebook.graphApi.placePosts
                .replace('${accessToken}', config.facebook.approvedApps[0])
                .replace('${placeId}', placeId), function (response) {
                _this.placeFeedPaging = response.paging;
                if (!!response.error) {
                    console.error(response.error);
                    _this.placeFeeds = [];
                    return;
                }
                _this.updatePlaceFeeds(response.data);
            });
        }
    };
    PlaceDetailsModalComponent.prototype.getFacebookPlaceFeed = function ($event) {
        if (!this.place) {
            return;
        }
        if (this.place.socialName === 'google' &&
            this.featuresToggle.facebookPosts &&
            FacebookLoginButtonComponent.isUserLoggedWithFacebook) {
            // search Facebook place API is deprecated
            //this.matchGooglePlaceWithFacebookPlace();
        }
        if (this.place.socialName === 'facebook') {
            if (FacebookLoginButtonComponent.isUserLoggedWithFacebook && !this.placeFeeds) {
                var id = ShareService.getFacebookPlaceId(this.place.hostLink);
                this.getFBPost(id);
            }
            // else {
            //     // the facebook login button component's loginStatusChange event cannot take effect here
            //     setTimeout(() => {
            //         this.getFacebookPlaceFeed(null);
            //     }, 3000);
            // }
        }
    };
    PlaceDetailsModalComponent.prototype.getNextFacebookPlaceFeed = function (event) {
        var _this = this;
        FB.api(this.placeFeedPaging.next, function (response) {
            event.complete();
            _this.placeFeedPaging = response.paging;
            if (!!response.error) {
                console.error(response.error);
                return;
            }
            _this.updatePlaceFeeds(_this.placeFeeds.concat(response.data));
        });
    };
    PlaceDetailsModalComponent.prototype.getGooglePlaceDetails = function (place) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, range, photos, isReal_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(place.socialName === 'google')) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, PlaceService.getGooglePlaceDetails(this.place, this.hubName, this.visitorApiService)];
                    case 1:
                        _a.googlePlaceAdditionalData = _b.sent();
                        if (this.googlePlaceAdditionalData.isNotExistInSource) {
                            this.alertify.error("Uh-oh! Looks like we haven't found this place! Please view other places in the list!");
                            this.dialogRef.close();
                            return [2 /*return*/];
                        }
                        this.googleReviews = this.googlePlaceAdditionalData
                            ? this.googlePlaceAdditionalData.googleReviews || this.googlePlaceAdditionalData.reviews
                            : [];
                        this.place.website =
                            this.place.website || (this.googlePlaceAdditionalData ? this.googlePlaceAdditionalData.website : null);
                        this.place.phone =
                            this.place.phone ||
                                (this.googlePlaceAdditionalData ? this.googlePlaceAdditionalData.formatted_phone_number : null);
                        this.place.hostGoogleLink = this.googlePlaceAdditionalData ? this.googlePlaceAdditionalData.url : null;
                        range = this.place.priceRange ||
                            (this.googlePlaceAdditionalData
                                ? this.googlePlaceAdditionalData.priceRange || this.googlePlaceAdditionalData.price_level
                                : null);
                        this.place.priceRange = range ? this.getPriceRangeSymbol(range) : '';
                        if (this.place.cover && this.place.cover.source) {
                            this.place.cover.source = this.imageService.imageSource(this.place);
                        }
                        photos = this.getPlaceImages();
                        isReal_1 = !!(this.googlePlaceAdditionalData.allowedGooglePhotos && this.googlePlaceAdditionalData.allowedGooglePhotos.length);
                        photos = photos.map(function (x) {
                            return PlaceService.getGooglePlaceImageFullUrl(x.photo_reference || x, _this.googlePlaceAdditionalData.appKey, isReal_1, false);
                        });
                        photos.shift();
                        this.placePhotos = [this.place.cover.source].concat(photos);
                        this.place.business_status = this.googlePlaceAdditionalData.business_status;
                        this.placeImagesShownCount = Math.min(this.placeImagesShownCount, this.placePhotos.length);
                        this.isGoogleInfoLoaded = true;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PlaceDetailsModalComponent.prototype.gotoPlace = function (place) {
        this.isGoogleInfoLoaded = false;
        this.isMatchCompleted = false;
        this.isGooglePlaceMatchedWithFBPlace = false;
        this.placeFeeds = null;
        this.placeFeedPaging = null;
        this.loadItem(place);
    };
    PlaceDetailsModalComponent.prototype.visitWebsite = function () {
        if (this.place.website || this.place.hostLink) {
            window.open(this.place.website || this.place.hostLink, '_blank');
        }
        else if (this.googlePlaceAdditionalData && this.googlePlaceAdditionalData.website) {
            window.open(this.googlePlaceAdditionalData.website, '_blank');
        }
    };
    PlaceDetailsModalComponent.prototype.getDirection = function () {
        var address = this.place.address.address || this.place.address;
        var url = config.eventShare.googleMapGetDirection.replace('${address}', encodeURIComponent(address.toString()));
        window.open(url, '_blank');
    };
    PlaceDetailsModalComponent.prototype.showPlaceLink = function () {
        this.modalService.show({
            component: ShowInfoModalComponent,
            providers: [
                { provide: ShowInfoModalActions, useValue: null },
                {
                    provide: InfoModalData,
                    useValue: new InfoModalData('Place Link', null, ["" + config.serverDomain + this.place.hubName + "/place-details/" + this.place._id], null, true),
                },
            ],
            panelClass: 'width-modal-4',
        });
    };
    PlaceDetailsModalComponent.prototype.viewFBPage = function () {
        if (this.place.hostLink || this.place.hostFacebookLink) {
            window.open(this.place.hostLink || this.place.hostFacebookLink, '_blank');
        }
    };
    PlaceDetailsModalComponent.prototype.loadItem = function (place) {
        var _this = this;
        if (!place) {
            return;
        }
        this.setImageSizeForGooglePlaces(place);
        this.imgComp && this.imgComp.updateImage(place.cover && place.cover.source);
        this.imgViewer && this.imgViewer.updateImage(place.cover && place.cover.source);
        place.category && (place.category = PlaceService.allToReadableCategory(place.category));
        this.place = place;
        this.processAddress();
        // this.loadPlaceMoreInfo();
        this.isAccommodation = PlaceService.checkIsAccommodation(this.place);
        if (!this.isScriptSolution) {
            SeoService.addNameIdToUrlForPlaceForNonScriptSolution(this.location, this.place, this.dialogRef);
        }
        else {
            // for clients who use the script solution (embed ImGoing as a script into client's website)
            // change the URL by adding the ImGoing place name + Id to the params so that each place has a unique URL
            // when close the details modal, reset the URL to the original URL of the host site
            if (SeoService.getIfNeedToAddNameIdToUrl()) {
                SeoService.addNameIdToUrlForPlaceForScriptSolution(place, this.dialogRef);
            }
        }
        setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            var code;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoadingAllPlaces = false;
                        this.setElementHeight();
                        this.placeFeeds = null;
                        this.placeFeedPaging = null;
                        this.getFacebookPlaceFeed(null);
                        this.place.priceRange = this.getPriceRangeSymbol(this.place.priceRange);
                        return [4 /*yield*/, this.getGooglePlaceDetails(place)];
                    case 1:
                        _a.sent();
                        if (this.place._360VideoKey) {
                            this._360Url = this.sanitizer.bypassSecurityTrustResourceUrl(config._360VideoUrl.replace('${id}', this.place._360VideoKey));
                        }
                        if (this.place.youtubeLink && this.place.youtubeLink.indexOf('watch?v=') >= 0) {
                            code = this.place.youtubeLink.split('watch?v=')[1].split('&')[0];
                            this._youtubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(config.youtubeUrl.replace('${code}', code));
                        }
                        SeoService.createAndInjectGoogleStructureDataScriptForPlace(this.place);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    PlaceDetailsModalComponent.prototype.loadPlaceMoreInfo = function () {
        var _this = this;
        this.isLoadingPlace = true;
        this.getPlaceById(this.place.hubName, this.place._id).subscribe(function (data) {
            if (data && data.length) {
                _this.place.description = data[0].description;
                _this.place.about = data[0].about;
                _this.place.address = data[0].address;
                _this.place.category = data[0].category;
                _this.processAddress();
            }
            _this.isLoadingPlace = false;
        });
    };
    PlaceDetailsModalComponent.prototype.processAddress = function () {
        var address = (this.place.address.address || this.place.address).toString();
        var addSegs = address.split(',');
        var last = addSegs[addSegs.length - 1];
        var cityArr = [], no = [];
        var take = parseInt(last, 10) ? 3 : 2;
        addSegs.forEach(function (x, index) {
            if (index < addSegs.length - take) {
                no.push(x);
            }
            else {
                cityArr.push(x);
            }
        });
        this.addressSegs = no.concat([cityArr.join(', ')]);
    };
    PlaceDetailsModalComponent.prototype.setElementHeight = function () {
        // let rect = this.mapColumnEle.nativeElement.getBoundingClientRect();
        // this.inforRowHeight = Math.min(rect.height, this.mapColumnMaxHeight);
        // this.mapColumnEle.nativeElement.style.height = this.inforRowHeight + 20 + 'px';
        // let desHeight = this.inforRowHeight - this.imageHeight - 25;//imageEleRect.height - 8;
        // this.descriptionEle.nativeElement.style.display = 'block';
        // this.descriptionEle.nativeElement.style.height = desHeight + 'px';
        // this.fbposts ? this.fbposts.nativeElement.style.height = (this.inforRowHeight - 32) + 'px' : null;
    };
    PlaceDetailsModalComponent.prototype.updatePlaceFeeds = function (placeFeeds) {
        var _this = this;
        this.placeFeeds = placeFeeds;
        this.placeFeeds.forEach(function (x) {
            x.from.link = config.facebook.graphApi.profile.replace('${userId}', x.from.id);
            x.from.picture = config.facebook.graphApi.profilePictureSquare.replace('${userId}', x.from.id);
        });
        // show 2 columns for facebook place
        if (this.show2ColumnsFacebookFeeds) {
            var col_1 = [];
            this.placeFeedRows = [];
            this.placeFeeds.forEach(function (x, i) {
                if (i && i % 2 === 0) {
                    _this.placeFeedRows.push(col_1);
                    col_1 = [];
                }
                col_1.push(x);
                if (i === _this.placeFeeds.length - 1) {
                    _this.placeFeedRows.push(col_1);
                }
            });
        }
    };
    Object.defineProperty(PlaceDetailsModalComponent.prototype, "show2ColumnsFacebookFeeds", {
        get: function () {
            return (this.place.socialName === 'facebook' || (this.place.socialName === 'google' && !this.featuresToggle.googleReviews));
        },
        enumerable: true,
        configurable: true
    });
    PlaceDetailsModalComponent.prototype.addGotoWebsiteCount = function () {
        this.analytics.gotoWebsiteCount++;
    };
    PlaceDetailsModalComponent.prototype.addGetDirectionCount = function () {
        this.analytics.getDirectionCount++;
    };
    PlaceDetailsModalComponent.prototype.addShareEmail = function () {
        this.analytics.shareEmailCount++;
    };
    PlaceDetailsModalComponent.prototype.addShareFB = function () {
        this.analytics.shareFBCount++;
    };
    PlaceDetailsModalComponent.prototype.addShareTweet = function () {
        this.analytics.shareTweetCount++;
    };
    PlaceDetailsModalComponent.prototype.addGoToGoogleReview = function () {
        this.analytics.gotoGoogleReview++;
    };
    PlaceDetailsModalComponent.prototype.getPlaceById = function (hubName, id) {
        return this.visitorApiService.getPlaces(hubName || this.place.hubName, {
            page: 1,
            limit: 1,
            category: 'All',
            id: id,
        });
    };
    PlaceDetailsModalComponent.prototype.setImageSizeForGooglePlaces = function (place) {
        if (place.cover &&
            place.cover.source &&
            place.cover.source.indexOf('maps.googleapis.com/maps/api/place/photo?maxwidth=480') >= 0) {
            place.cover.source = place.cover.source.replace('maxwidth=480', 'maxwidth=960');
        }
    };
    PlaceDetailsModalComponent.prototype.matchGooglePlaceWithFacebookPlace = function () {
        var _this = this;
        PlaceService.getMatchedFacebookPlaceId(this.place, this.hubName, this.visitorApiService).then(function (data) {
            console.log(data);
            _this.isMatchCompleted = true;
            if (data.isMatched) {
                _this.isGooglePlaceMatchedWithFBPlace = true;
                // this.place.description = data.description;
                _this.place.hostFacebookLink = data.link;
                var id = ShareService.getFacebookPlaceId(data.link);
                _this.getFBPost(id);
            }
            else {
                _this.placeFeeds = []; // no Facebook posts
            }
        });
    };
    PlaceDetailsModalComponent.prototype.getPlaceImages = function () {
        if (this.googlePlaceAdditionalData.allowedGooglePhotos &&
            this.googlePlaceAdditionalData.allowedGooglePhotos.length) {
            return this.googlePlaceAdditionalData.allowedGooglePhotos;
        }
        // use the cover image to replace the first one in the photos, to reduce request calls
        if (this.googlePlaceAdditionalData.photos && this.googlePlaceAdditionalData.photos.length) {
            this.googlePlaceAdditionalData.photos.shift();
            this.googlePlaceAdditionalData.photos.unshift({
                height: 0,
                photo_reference: this.place.cover ? this.place.cover.source : 'null',
                width: 0,
                html_attributions: null,
            });
            return this.googlePlaceAdditionalData.photos;
        }
        if (this.place.cover && this.place.cover.source) {
            return [this.place.cover.source];
        }
        return [];
    };
    PlaceDetailsModalComponent.prototype.getPriceRangeSymbol = function (price) {
        if (!price)
            return '';
        if (price.toString().startsWith('$'))
            return price.toString();
        var array = [];
        for (var i = 0; i < +price; i++) {
            array.push('$');
        }
        return array.join('');
    };
    return PlaceDetailsModalComponent;
}(BaseComponent));
export { PlaceDetailsModalComponent };
var Analytics = /** @class */ (function () {
    function Analytics() {
        this.getDirectionCount = 0;
        this.gotoGoogleReview = 0;
        this.shareEmailCount = 0;
        this.shareFBCount = 0;
        this.shareTweetCount = 0;
    }
    return Analytics;
}());
export { Analytics };
var PlaceAnalytics = /** @class */ (function (_super) {
    __extends(PlaceAnalytics, _super);
    function PlaceAnalytics() {
        var _this = _super.call(this) || this;
        _this.gotoWebsiteCount = 0;
        return _this;
    }
    return PlaceAnalytics;
}(Analytics));
export { PlaceAnalytics };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.details.modal/place.details.modal.component.ts.pre-build-optimizer.js